import { create } from 'zustand';

import { type Account, type AccountFeature } from '@services/AccountService';

export type AccountStatus = 'unknown' | 'ready';

export type AccountStore = {
  status: AccountStatus;
  account: Account | null;
  isLoading: boolean;
  isAutoRetrySpent: boolean;
  isSearchAgesHydrationSpent: boolean;
  setAccount: (account: Account) => void;
  setLoading: (isLoading: boolean) => void;
  spendAutoRetry: () => void;
  spendSearchAgesHydration: () => void;
  disableFeature: (feature: AccountFeature) => void;
};

export const useAccountStore = create<AccountStore>()((set) => ({
  status: 'unknown',
  account: null,
  isLoading: false,
  isAutoRetrySpent: false,
  isSearchAgesHydrationSpent: false,
  setAccount: (account) => set({ status: 'ready', account }),
  setLoading: (isLoading) => set({ isLoading }),
  spendAutoRetry: () => set({ isAutoRetrySpent: true }),
  spendSearchAgesHydration: () => set({ isSearchAgesHydrationSpent: true }),
  disableFeature: (feature) =>
    set(({ account }) =>
      account
        ? {
            account: {
              ...account,
              features: { ...account.features, [feature]: false },
            },
          }
        : {},
    ),
}));
